import React from "react";
import TextField from "@mui/material/TextField";
import { useTranslation } from "react-i18next";
import ButtonComponent from "../../components/ButtonComponent";
import { COLORS } from "../../lib/colors";

function Filter(props) {
  const { t } = useTranslation();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-around",
        alignItems: "center",
        marginTop: 30,
        backgroundColor: "#ffe2a4",
        borderRadius: "16px 16px 0 0",
      }}
    >
      <ButtonComponent
        backgroundColor={COLORS.primary}
        // width="5%"
        onClick={props.removeFilters}
        style={{ marginLeft: 5 }}
      >
        {t("components.dataTable.filter.showAllBtn")}
      </ButtonComponent>

      <TextField
        id="standard-select-filter-input"
        select
        label="Filter by month "
        value={props.month}
        onChange={props.handleChange}
        SelectProps={{
          native: true,
        }}
        size="medium"
        helperText="Please select the desired month"
        style={{ width: 200 }}
      >
        {props.children}
      </TextField>

      <ButtonComponent
        backgroundColor={COLORS.primary}
        // width="5%"
        onClick={props.getLastmonth}
        style={{ marginLeft: 5 }}
      >
        {t("components.dataTable.filter.showLastMonthBtn")}
      </ButtonComponent>

      <ButtonComponent
        backgroundColor={COLORS.primary}
        // width="5%"
        onClick={props.getCurrentmonth}
        style={{ marginLeft: 5 }}
      >
        {t("components.dataTable.filter.showCurrentMonthBtn")}
      </ButtonComponent>

      <ButtonComponent
        backgroundColor={COLORS.primary}
        // width="5%"
        onClick={props.getLastweek}
        style={{ marginLeft: 5 }}
      >
        {t("components.dataTable.filter.showcurrentWeekBtn")}
      </ButtonComponent>
    </div>
  );
}

export default Filter;
